import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ForwardIcon,
  PaperAirplaneIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { setUserCommentsAction } from '../../reduxstore/actions/authActions';

const sections = [
  'Process and Finish',
  'Verification and Validation',
  'Logistics',
  'Additional Documents',
  'Project Discription',
  'NDA',
];

const CommentPopup = ({ setCommentPopup, Section }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.authReducer?.user);
  const commentsData = useSelector(
    (state) => state?.authReducer?.user?.comments,
  );
  const [currentSection, setCurrentSection] = useState(Section);
  const [comment, setComment] = useState('');
  const [atBottom, setAtBottom] = useState(false);
  const commentScrollerRef = useRef(null);

  const handleCommentSubmit = () => {
    // setting comment data
    const newComment = {
      comment: comment,
      user: 'Supplier',
    };

    const updatedCommentsData = {
      ...commentsData,
      [currentSection]: [...commentsData[currentSection], newComment],
    };

    dispatch(setUserCommentsAction(updatedCommentsData));
    setComment('');
  };

  // Scroll to the bottom after each render
  useEffect(() => {
    if (commentScrollerRef.current) {
      commentScrollerRef.current.scrollTop =
        commentScrollerRef.current.scrollHeight;
    }
  }, [commentsData]);

  // const prevScrollTop = useRef(0);
  // console.log(atBottom);

  // const handleScroll = () => {
  //     if (commentScrollerRef.current) {
  //         const { scrollTop, scrollHeight, clientHeight } =
  //             commentScrollerRef.current;
  //         const isScrollingDown = scrollTop > prevScrollTop.current;
  //         prevScrollTop.current = scrollTop;

  //         if (scrollTop + clientHeight === scrollHeight) {
  //             setAtBottom(true);
  //         } else {
  //             setAtBottom(false);
  //         }
  //     }
  // };

  // useEffect(() => {
  //     if (commentScrollerRef.current) {
  //         commentScrollerRef.current.addEventListener("scroll", handleScroll);
  //     }
  // }, [currentSection]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="relative bg-white p-4 py-8 rounded-3xl flex flex-col h-5/6 w-1/2">
        <XMarkIcon
          className="h-6 w-6 absolute top-5 right-5"
          onClick={() => setCommentPopup({ visible: false })}
        />
        <p className="font-semibold text-3xl text-center ">Comment</p>
        <div className="flex flex-row mt-6 overflow-x-scroll overflow-hidden sectionScroller min-h-[60px]">
          {sections &&
            sections.map((section, index) => (
              <div
                key={index}
                className={`rounded-full mr-3  mt-2 mb-2 p-2 border border-neutral-300 whitespace-nowrap ${
                  currentSection === section
                    ? 'bg-blue-400 border-0 text-white font-semibold'
                    : 'hover:cursor-pointer'
                }`}
                onClick={() => {
                  setAtBottom(false);
                  setComment('');
                  setCurrentSection(section);
                }}
              >
                {section}
              </div>
            ))}
        </div>

        <div
          className="mt-5 space-y-4 overflow-y-auto commentScroller pr-2"
          ref={commentScrollerRef}
        >
          {commentsData &&
            commentsData[currentSection] &&
            commentsData[currentSection].map((comment, index) => (
              <div className="flex flex-col px-5 py-2 rounded-2xl bg-[#F7FAFF] border border-[#D2DCF2]">
                <div className="flex flex-row space-x-3">
                  <img
                    className="h-12 w-12 rounded-full"
                    src={
                      comment.user === 'MakerSharks'
                        ? '/logo1.svg'
                        : user?.picture
                    }
                    alt="user"
                  />
                  <div>
                    <p className="text-[#28384E] font-bold">{comment.user}</p>
                    <div className="text-[13.33px] mt-2">{comment.comment}</div>
                  </div>
                </div>
              </div>
            ))}
          <div className="flex flex-row space-x-2 items-center">
            <div className="flex flex-row flex-grow px-5 py-2 bg-white border border-neutral-200 rounded-2xl items-center">
              <div>
                <img
                  className="h-12 w-12 rounded-full"
                  src={user?.picture}
                  alt="user"
                />
              </div>
              <div className="flex-grow px-5">
                <input
                  type="text"
                  name="comment"
                  id="comment"
                  className="relative px-2 py-1 bg-white w-full rounded-full hover:cursor-pointer text-[13.33px] font-normal focus:outline-none placeholder:text-black sm:text-sm sm:leading-6 placeholder:italic placeholder:text-[13.33px]"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && comment !== '') {
                      handleCommentSubmit();
                    }
                  }}
                  placeholder="Add a suggestion or comment..."
                />
              </div>
              <PaperAirplaneIcon
                className="h-6 w-6 hover:cursor-pointer"
                onClick={() => handleCommentSubmit()}
              />
            </div>
            {atBottom && (
              <div className="px-2 py-5 bg-white border border-neutral-200 rounded-2xl hover:bg-blue-400 hover:text-white hover:cursor-pointer">
                <ForwardIcon
                  className="h-6 w-6  "
                  onClick={() => {
                    const index = sections.findIndex(
                      (sec) => sec === currentSection,
                    );
                    setCurrentSection(sections[index + 1]);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentPopup;
